var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublic(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46875 0.897461C3.65057 0.897461 1.46875 5.09746 1.46875 5.09746C1.46875 5.09746 3.65057 9.29746 7.46875 9.29746C11.2869 9.29746 13.4688 5.09746 13.4688 5.09746C13.4688 5.09746 11.2869 0.897461 7.46875 0.897461Z",
    stroke: "#BBBBBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46875 6.89746C8.46286 6.89746 9.26875 6.09157 9.26875 5.09746C9.26875 4.10335 8.46286 3.29746 7.46875 3.29746C6.47464 3.29746 5.66875 4.10335 5.66875 5.09746C5.66875 6.09157 6.47464 6.89746 7.46875 6.89746Z",
    stroke: "#BBBBBB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublic);
export default __webpack_public_path__ + "static/media/public.7a14070b4894ca4d412d5b904837716b.svg";
export { ForwardRef as ReactComponent };